<template>
	<div class="bg-dark-mode">
		<HomeNav  v-if="userNotLoggedin == true"/>
		<header class="masthead mb-auto" v-if="userNotLoggedin == false">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoLogin"
						>
							login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="privacy-banner d-flex flex-column">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 col-lg-8 col-xl-8">
						<h3 class="my-5 font-semibold">IBAKATV Privacy Policy</h3>
					</div>
				</div>
			</div>
			<div class="page-icon bg-primary">
				<img src="../assets/img/privacy-icn.svg" alt="" />
			</div>
		</section>
		<section class="bg-cookies-container">
			<div class="container tab-pane fade show active" id="mediacenter">
				<div class="row justify-content-center">
					<div class="col-md-8 col-lg-8 col-xl-8">
						<h5 class="font-semibold mb-4 mt-4">Overview</h5>
						<p>
							At Ibaka Entertainment Limited (the “Company”); we recognize your
							privacy is important. This Policy explains the Company’s privacy
							practices on its website iBAKATV (the “Site”).
						</p>
						<p>
							This Policy also explains what information we collect about you
							(the “User”) and how we use this information. This Privacy Policy
							is designed to be read in connection with the Site’s Terms of use,
							which is available here Types of Information we collect All User
							information supplied by Users of iBAKATV.com as defined under the
							terms & conditions is covered by the Data Protection Act of 1998.
						</p>
						<h6 class="font-semibold my-4">
							1. What Information Do We Collect?
						</h6>
						<p>
							We collect personally identifiable information and Aggregate
							Information.
						</p>
						<div class="pl-5">
							<p>
								<span class="font-semibold"
									>Personally Identifiable Information (“PII”):</span
								>
								This is information that lets us know the specifics of who you
								are, and includes, but is not limited to your Contact Data (such
								as your first and last name, physical street address, phone
								number and email address).
							</p>
							<p>
								<span class="font-semibold">Aggregate Information: </span> This
								is information that does not identify you as an individual. We
								collect anonymous data which includes, but is not limited to (i)
								IP address, (ii) Domain servers, and (iii) type of computer used
								to access our Site. Our external third party advertising
								partners may also collect aggregate information but not
								personally identifiable information. How we collect and use
								information We collect information Users provide when
								registering to use our Site. Through a combination of cookies
								and external third party tracking, we track information when
								Users visit or use our Site. We use PII and Aggregate
								information to enhance the consumer experience on the Site and
								the operation of our Site. We may also use your PII, to provide
								you with information and promotions regarding our products, to
								contact you regarding administrative notices, or to contact you
								regarding an order or, to respond to a question or request.
								However, our use of the information is not limited to the uses
								above and, one or more of such uses may apply simultaneously.
							</p>
						</div>
						<h6 class="font-semibold my-4">2. Cookies</h6>
						<p>
							This site uses cookies. A cookie is a small data text file placed
							on the User’s computer. We use cookies to collect certain
							aggregate date about our Users, to deliver content specific to
							your interest and to prevent you entering login information at
							each connection. Also, the cookie enhances User experience and
							interaction with the Site. Users may choose not to accept cookies,
							but this may prevent the Site from functioning properly. We may
							also use external third party advertising partners to display
							advertisement on the Site. As part of their services, they will
							place a separate cookie on your computer to help them precisely
							target advertising to you. Our third party advertising partners do
							not collect personally identifiable information. Most browsers are
							initially set up to accept cookies, but you can reset your browser
							to refuse all cookies or to indicate when a cookie is being sent.
							However, doing so means that you will not be presented with
							advertising that reflects the way that you use our, and other,
							websites and may adversely affect your experience of websites that
							use cookies to enhance or personalize that experience. You can
							find out how to make these changes to your browser at this site.
						</p>
						<p>
							To help you better understand how we use cookies, please see the
							information below:
						</p>
						<div class="pl-5">
							<p>
								<span class="font-semibold">Essential cookies:</span> These
								cookies are strictly necessary to provide our website or online
								service. For example, we and our Service Providers may use these
								cookies to authenticate and identify our members when they use
								our websites and applications so we can provide our service to
								them. They also help us to enforce our Terms of Use, prevent
								fraud and maintain the security of our service.
							</p>
							<p>
								<span class="font-semibold"
									>Performance and functionality cookies:</span
								>
								These cookies are not essential, but they help us to personalize
								and enhance your online experience with Netflix. For example,
								they help us to remember your preferences and prevent you from
								needing to re-enter information you previously provided (for
								example, during member sign up). We also use these cookies to
								collect information (such as popular pages, conversion rates,
								viewing patterns, click through and other information) about our
								visitors’ use of the Netflix service so that we can enhance and
								personalize our website and service and conduct market research.
								Deletion of these types of cookies may result in limited
								functionality of our service.
							</p>
							<p>
								<span class="font-semibold"
									>Advertising cookies and resettable device identifiers:</span
								>
								These cookies and resettable device identifiers use information
								about your use of this and other websites and apps, your
								response to ads and emails, and to deliver ads that are more
								relevant to you and for analytics and optimization purposes.
								These types of ads are called “interest-based advertising.” Many
								of the advertising cookies associated with our service belong to
								our Service Providers.
							</p>
						</div>
						<h6 class="font-semibold my-4">3. Release of Information</h6>
						<p>
							We will not sell, trade, or rent your PII to other parties without
							your consent. But, we may share your PII with our current or
							future “affiliates” (which means a Parent Company, subsidiary or
							company under common control), in which case we would require our
							affiliates to honour this Privacy Policy. However, the use of your
							PII by our Service Partners, is governed by the respective privacy
							policies of those partners, and is not subject to our control.
							Please consult each site’s privacy policy. Except as otherwise
							discussed in this Privacy Policy, this document only addresses the
							use and disclosure of information we collect from you. We are not
							responsible for the policies and practices of third parties. We
							may disclose your PII as required by law, such as to comply with a
							subpoena or, similar legal process; and when we believe in good
							faith that disclosure is necessary to protect our rights, protect
							your safety or the safety of others, investigate fraud, or respond
							to a government request.
						</p>
						<h6 class="font-semibold my-4">
							4. Correction and updating your information
						</h6>
						<p>
							Users can modify or change their password, and e-mail address by
							through their “My Profile” settings. Also, Users can modify,
							change or delete their personal information anytime by emailing us
							at support@ibakatv.com or calling us on +234-81-601-32338 or
							+234-81-601-32338. Users can access the information held on them
							on the Site by emailing us at support@ibakatv.com . The Company
							makes a nominal charge of $ 7, to cover administration costs.
						</p>
						<h6 class="font-semibold my-4">5. Opt Out</h6>
						<p>
							Users may opt out of receiving communications from us by following
							directions in our e-mail to “unsubscribe” from our mailing list,
							or by sending an e-mail request to support@ibakatv.com or calling
							us on +234-81-601-3233. <br />You may opt out of interest based
							advertising from third party advertising agencies here
						</p>
						<h6 class="font-semibold my-4">6. Other websites and links</h6>
						<p>
							Our Site contains links to other third party websites or links
							(“Linked Websites”). <br />This Privacy Policy does not cover
							collection or use of information by Linked Websites. We are not
							responsible for the privacy practices of Linked Websites. If you
							have questions about the privacy policies or practices of a Linked
							Website; you should contact the web administrator of the site
							directly.
						</p>
						<h6 class="font-semibold my-4">7. Children/Age Restriction</h6>
						<p>
							Users must be at least 18 years old, or the age of majority in
							their province, territory or country, to have our permission to
							use this Site. Individuals under the age of 18, or applicable age
							of majority, may utilize the service only with involvement of a
							parent or legal guardian, under such person’s account and
							otherwise subject to the Site’s Terms of use. Our policy is that
							we do not knowingly collect, use or disclose personally
							identifiable information about minor visitors.
						</p>
						<h6 class="font-semibold my-4">8. Security</h6>
						<p>
							We transmit and store the information we collect using standard
							security techniques. However, given the nature of the Internet and
							the fact that network security measures are not foolproof, we
							cannot guarantee the security of such information.
						</p>
						<h6 class="font-semibold my-4">9. Transfer of Information</h6>
						<p>
							This Site processes information about our Users on servers located
							in a number of countries. The Company may also subcontract
							processing or sharing of information to third parties located in
							other countries, other than your home country. Also, such
							information may be transferred to another company if ownership of
							IEL changes. Therefore, information may be transferred across
							international borders outside the country where you use our
							services, including to countries that do not have laws providing
							specific protection for personal data or those that have different
							legal rules on data protection. You expressly consent to this.
							Retention We may retain PII information about the User, as long as
							it is necessary for business purposes. Also, we may retain
							aggregated anonymous information indefinitely. In addition, we may
							retain your information for an additional period as is permitted
							or required to, among other things, comply with our legal
							obligations, resolve disputes, and enforce agreements.
						</p>
						<h6 class="font-semibold my-4">
							10. Changes to the Privacy Policy
						</h6>
						<p>
							We may make changes to this Privacy Policy from time to time, and
							for any reason. You are advised to consult this privacy policy
							regularly for any changes, as we deem your continued use,
							following posting of any amendment, modification or change,
							approval of all changes.
						</p>
						<h6 class="font-semibold my-4">11. Contact Us</h6>
						<p>
							If you have any questions concerning this Privacy Policy please
							contact us at
							<a href="mailto:support@ibakatv.com." class="link"
								>support@ibakatv.com.</a
							>
						</p>
						<p>
							IBAKA ENTERTAINMENT LIMITED <br />
							<span class="font-semibold"> Corporate Office:</span> 5701 Shingle
							Creek Parkway, suit 420C Brooklyn Center, MN 55429<br />
							<span class="font-semibold"> Phone: </span> 540-40I-BAKA,
							540-40I-BAKA
						</p>
						<p>
							<span class="font-semibold"> Operational Office:</span> <br />
							688c, Jacob Nwakolo Close, Off Odujinrin Avenue, Omole Phase 2,
							Lagos State, Nigeria.<br />
							<span class="font-semibold"> Phone: </span> +234-81-601-32338,
							+234-81-601-32338.
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style scoped>




</style>

<script>
import HomeNav from "@/components/HomeNav.vue";
export default {
	name: "CookiesPrivacy",
	components: {
		HomeNav,
	},
	computed: {
		userNotLoggedin() {
			if( this.$store.state.user.logedin){
				return true
			} else{
				return false
			}
		},
	},
	created() {
		this.$store.commit("showdefaultFooter", true);
	},
	mounted() {
		window.scroll(0, 0);
	},

	methods: {
		gotoLogin() {
			this.$router.push("/login");
		},
		removeErr() {
			this.showresmsg = false;
		},
		ValidateEmail(mail) {
			var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (mail.match(mailformat)) {
				return true;
			} else {
				// alert("You have entered an invalid email address!");
				return false;
			}
		},
		contact() {
			this.isActive = true;
			self.showerr = false;
			if (this.docontact) {
				var DataToSend = {
					phone: "",
					email: this.email,
					description: this.msg,
					title: this.subject,
				};

				self = this;
				if (this.ValidateEmail(DataToSend.email)) {
					this.$store.dispatch("contactus", DataToSend).then((res) => {
						self.showresmsg = "Your email has been sent to site admin";
						self.showerr = true;
					});
				} else {
					self.showresmsg = "Invalid Email Entred";
					self.showerr = true;
				}
			}
		},
	},

	data() {
		return {
			isActive: false,
			docontact: true,
			userid: "",
			password: "",
			title: "",
			email: "",
			phno: "",
			subject: "",
			msg: "",
			showerr: false,
			showresmsg: "",
		};
	},
};
</script>
